var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1.94531 7.90579h28.10983c1.07262 0 1.94486-.87224 1.94486-1.94485s-.87224-1.94531-1.94485-1.94531h-28.10984c-1.07261 0-1.94531.8727-1.94531 1.94531s.8727 1.94485 1.94531 1.94485z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.05515 14.05469h-28.10984c-1.07261 0-1.94531.8727-1.94531 1.94531s.8727 1.94485 1.94531 1.94485h28.10983c1.07262 0 1.94486-.87224 1.94486-1.94485s-.87224-1.94531-1.94485-1.94531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.05515 24.09375h-28.10984c-1.07261 0-1.94531.87316-1.94531 1.94577s.8727 1.94485 1.94531 1.94485h28.10983c1.07261 0 1.94485-.87224 1.94485-1.94485s-.87223-1.94577-1.94484-1.94577z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.fdd6ad6a.svg";
export { ForwardRef as ReactComponent };